import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
const push = VueRouter.prototype.push
VueRouter.prototype.push = function(location) {
  return push.call(this, location).catch((err) => err)
}
const replace = VueRouter.prototype.replace
VueRouter.prototype.replace = function(location) {
  return replace.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // redirect: '/emailPush?columnId=2-2',
    children: [
      {
        path: '/postAnalysis',
        name: 'postAnalysis',
        component: () => import('../views/postAnalysis/index.vue')
      },
      {
        path: '/emailPush',
        name: 'emailPush',
        component: () =>
          import('../views/activeCommunication/emailPush/index.vue')
      },
      {
        path: '/emailPushList',
        name: 'emailPushList',
        component: () =>
          import('../views/activeCommunication/emailPush/emailPushList.vue')
      },
      {
        path: '/emailPreviewHtml',
        name: 'emailPreviewHtml',
        component: () =>
          import('../views/activeCommunication/emailPush/emailPreviewHtml.vue')
      },
      {
        path: '/weChatPush',
        name: 'weChatPush',
        component: () =>
          import('../views/activeCommunication/weChatPush/index.vue')
      },
      {
        path: '/pictrueTextMsg',
        name: 'pictrueTextMsg',
        component: () =>
          import('../views/activeCommunication/weChatPush/pictrueTextMsg.vue')
      },
      {
        path: '/singleEffect',
        name: 'singleEffect',
        component: () =>
          import(
            '../views/activeCommunication/communicationEffect/singleEffect.vue'
          )
      },
      {
        path: '/communicationEffect',
        name: 'communicationEffect',
        component: () =>
          import('../views/activeCommunication/communicationEffect/index.vue')
      },
      {
        path: '/citationTrackingPage',
        name: 'citationTrackingPage',
        component: () =>
          import('../views/activeCommunication/citationTracking/index.vue')
      },
      {
        path: '/citationTrackingDetails',
        name: 'citationTrackingDetails',
        component: () =>
          import(
            '../views/activeCommunication/citationTracking/citationTrackingDetails.vue'
          )
      },
      {
        path: '/details',
        name: 'details',
        component: () =>
          import(
            '../views/activeCommunication/communicationEffect/articleDetails.vue'
          )
      },
      {
        path: '/report',
        name: 'report',
        component: () =>
          import('../views/activeCommunication/communicationEffect/report.vue')
      },
      {
        path: '/analysisReport',
        name: 'analysisReport',
        component: () =>
          import(
            '../views/activeCommunication/communicationEffect/analysisReport.vue'
          )
      },
      {
        path: '/analysisYearReport',
        name: 'analysisYearReport',
        component: () =>
          import(
            '../views/activeCommunication/communicationEffect/analysisYearReport.vue'
          )
      },
      {
        path: '/highlyCitedArticles',
        name: 'highlyCitedArticles',
        component: () =>
          import('../views/contentAggregation/highlyCitedArticles.vue')
      },
      {
        path: '/priorityPublication',
        name: 'priorityPublication',
        component: () =>
          import('../views/contentAggregation/priorityPublication.vue')
      },
      {
        path: '/publishedJournals',
        name: 'publishedJournals',
        component: () =>
          import('../views/contentAggregation/publishedJournals/index.vue')
      },
      {
        path: '/publishedJournalsDetails',
        name: 'publishedJournalsDetails',
        component: () =>
          import(
            '../views/contentAggregation/publishedJournals/publishedJournalsDetails.vue'
          )
      },
      {
        path: '/academicInformation',
        name: 'academicInformation',
        component: () =>
          import('../views/informationAggregation/academicInformation.vue')
      },
      {
        path: '/conferenceInformation',
        name: 'conferenceInformation',
        component: () =>
          import('../views/informationAggregation/conferenceInformation.vue')
      },
      {
        path: '/citationTracking',
        name: 'citationTracking',
        component: () => import('../views/citationTracking/index.vue')
      },
      {
        path: '/downloadIssueReport',
        name: 'downloadIssueReport',
        component: () =>
          import('../views/downloadReport/downloadIssueReport.vue')
      },
      {
        path: '/downloadYearReport',
        name: 'downloadYearReport',
        component: () =>
          import('../views/downloadReport/downloadYearReport.vue')
      },
      {
        path: '/noData',
        name: 'noData',
        component: () => import('../views/noData.vue')
      },
      // 新菜单路由配置 - 数据综览
      {
        path: '/newDataOverview',
        name: 'newDataOverview',
        component: () => import('../views/dataOverview/index.vue')
      },
      // 新菜单路由配置 - 主动推送
      {
        path: '/newActivePushDesktop',
        name: 'newActivePushDesktop',
        component: () => import('../views/activePush/desktop.vue')
      },
      {
        path: '/newActivePushEmail',
        name: 'newActivePushEmail',
        component: () => import('../views/activePush/email.vue')
      },
      {
        path: '/newActivePushSettings',
        name: 'newActivePushSettings',
        component: () => import('../views/activePush/settings.vue'),
        redirect: '/newActivePushSettings/pushConfig',
        children: [
          {
            path: 'pushConfig',
            name: 'pushConfig',
            component: () =>
              import('../views/activePush/settings/pushConfig.vue')
          },
          {
            path: 'journalConfig',
            name: 'journalConfig',
            component: () =>
              import('../views/activePush/settings/journalConfig.vue')
          },
          {
            path: 'matchAlgorithm',
            name: 'matchAlgorithm',
            component: () =>
              import('../views/activePush/settings/matchAlgorithm.vue')
          },
          {
            path: 'matchAlgorithmConfig',
            name: 'matchAlgorithmConfig',
            component: () =>
              import(
                '../views/activePush/settings/matchAlgorithmConfig.vue'
              )
          },
          {
            path: 'settingsTemplateConfig',
            name: 'settingsTemplateConfig',
            component: () =>
              import('../views/activePush/settings/settingsTemplateConfig.vue')
          },
          {
            path: 'whitelist',
            name: 'whitelist',
            component: () =>
              import('../views/activePush/settings/whitelist.vue')
          },
          {
            path: 'senderMailbox',
            name: 'senderMailbox',
            component: () =>
              import('../views/activePush/settings/senderMailbox.vue')
          },
          {
            path: 'settingsTemplateConfigDetail',
            name: 'settingsTemplateConfigDetail',
            component: () =>
              import(
                '../views/activePush/settings/settingsTemplateConfigDetail.vue'
              )
          }
        ]
      },
      {
        path: '/newActivePushReport',
        name: 'newActivePushReport',
        component: () => import('../views/activePush/report.vue')
      },
      // 新菜单路由配置 - 订阅推送
      {
        path: '/newSubscribePushDashboard',
        name: 'newSubscribePushDashboard',
        component: () => import('../views/subscribePush/dashboard.vue')
      },
      {
        path: '/newSubscribePushEmailAlert',
        name: 'newSubscribePushEmailAlert',
        component: () => import('../views/subscribePush/emailAlert.vue'),
        redirect: '/newSubscribePushEmailAlert/subscriptionAnalysis',
        children: [
          {
            path: 'subscriptionAnalysis',
            name: 'subscriptionAnalysis',
            component: () =>
              import(
                '../views/subscribePush/emailAlert/subscriptionAnalysis.vue'
              )
          },
          {
            path: 'pushAnalysis',
            name: 'pushAnalysis',
            component: () =>
              import('../views/subscribePush/emailAlert/pushAnalysis.vue')
          }
        ]
      },
      {
        path: '/newSubscribePushCited',
        name: 'newSubscribePushCited',
        component: () => import('../views/subscribePush/cited.vue')
      },
      // 新菜单路由配置 - 微信推送
      {
        path: '/newWeChatPush',
        name: 'newWeChatPush',
        component: () => import('../views/weChatPush/index.vue')
      },
      // 新菜单路由配置 - 被引推送
      {
        path: '/newCitedPushTask',
        name: 'newCitedPushTask',
        component: () => import('../views/citedPush/task.vue')
      },
      {
        path: '/citedEmailPreview',
        name: 'citedEmailPreview',
        component: () => import('../views/citedPush/citedEmailPreview.vue')
      },
      // 新菜单路由配置 - 订阅推送 - 模板配置
      {
        path: '/citedPushTemplateConfig',
        name: 'citedPushTemplateConfig',
        component: () =>
          import('../views/citedPush/citedPushTemplateConfig.vue')
      },
      {
        path: '/citedPushTemplateConfigDetail',
        name: 'citedPushTemplateConfigDetail',
        component: () =>
          import('../views/citedPush/citedPushTemplateConfigDetail.vue')
      },
      {
        path: '/newCitationStatsData',
        name: 'newCitationStatsData',
        component: () => import('../views/citedPush/dashboard.vue')
      },
      {
        path: '/newCitationStatsDataDetail',
        name: 'newCitationStatsDataDetail',
        component: () => import('../views/citedPush/dashboardDetail.vue')
      },
      {
        path: '/citationStatsTemplateConfig',
        name: 'citationStatsTemplateConfig',
        component: () =>
          import('../views/citationStats/citationStatsTemplateConfig.vue')
      },
      {
        path: '/citationStatsTemplateConfigDetail',
        name: 'citationStatsTemplateConfigDetail',
        component: () =>
          import('../views/citationStats/citationStatsTemplateConfigDetail.vue')
      },
      // 新菜单路由配置 - 引证统计
      {
        path: '/newCitationStats',
        name: 'newCitationStats',
        component: () => import('../views/citationStats/index.vue')
      },
      // 新菜单路由配置 - 用户分析
      {
        path: '/newUserAnalysis',
        name: 'newUserAnalysis',
        component: () => import('../views/userAnalysis/index.vue')
      },
      {
        path: '/newUserAnalysisDetail',
        name: 'newUserAnalysisDetail',
        component: () => import('../views/userAnalysis/indexDetail.vue')
      },
      // 步骤页面路由配置
      {
        path: '/steps',
        name: 'Steps',
        component: () => import('../views/steps/index.vue'),
        redirect: '/steps/paperList',
        children: [
          {
            path: '/steps/paperList',
            name: 'PaperList',
            component: () => import('../views/steps/PaperList.vue')
          },
          {
            path: '/steps/emailTemplate',
            name: 'EmailTemplate',
            component: () => import('../views/steps/EmailTemplate.vue')
          },
          {
            path: '/steps/selectScholars',
            name: 'SelectScholars',
            component: () => import('../views/steps/SelectScholars.vue')
          },
          {
            path: '/steps/viewScholars',
            name: 'ViewScholars',
            component: () => import('../views/steps/ViewScholars.vue')
          },
          {
            path: '/steps/pushTest',
            name: 'PushTest',
            component: () => import('../views/steps/PushTest.vue')
          },
          {
            path: '/steps/officialPush',
            name: 'OfficialPush',
            component: () => import('../views/steps/OfficialPush.vue')
          },
          {
            path: '/steps/EmailTemplatePreview',
            name: 'EmailTemplatePreview',
            component: () => import('../views/steps/EmailTemplatePreview.vue')
          },
          {
            path: '/steps/ScholarPanel',
            name: 'EmailTemplatePrScholarPaneleview',
            component: () => import('../views/steps/ScholarPanel.vue')
          },
          {
            path: '/journalList',
            name: 'JournalList',
            component: () => import('../views/activePush/journalList.vue')
          },
          {
            path: '/newActivePushAnalysis',
            name: 'newActivePushAnalysis',
            component: () => import('../views/activePush/analysis.vue')
          },
          {
            path: '/effectComparison',
            name: 'effectComparison',
            component: () => import('../views/activePush/effectComparison.vue')
          }
        ]
      }
    ]
  }
]

export default routes
